import BaseView from "../views/base-view";
import DoorView from "../views/door-view";
import DrawerView from "../views/drawer-view";
import ParametricPartView from "../views/parametric-part-view";
import SectionView from "../views/section-view";
import visibleSize from "./visible-size";
import { Object3D, Box3 } from "three";
import { approxGreaterThan, approxLessThan, approxOverlaps } from "../measurement";

/**
 * Detects if the given interval (y, y+height) overlaps any of the children
 * of the given SectionView, excluding doors. That is, this checks for
 * intersections on the interior of the unit, not on the front face of the
 * unit.
 */
export const overlapsSectionContent =
    (view: SectionView, y: number, height: number, item: Object3D)
        : boolean =>
{
    const box = new Box3();
    for(const child of view.children) {
        if(child == item) continue;
        if(child instanceof DoorView) continue;

        // We need to special-case the interaction between a fixed shelf and
        // a drawer
        let
            fixed: ParametricPartView,
            fixedY: number,
            drawer: DrawerView,
            drawerBottom: number,
            drawerTop: number;
        if(child instanceof ParametricPartView
           && child.name.startsWith('Fixed')
           && item instanceof DrawerView)
        {
            fixed = child;
            fixedY = child.model.position.y;
            drawer = item;
            drawerBottom = y;
            drawerTop = y + height;
        }
        else if(item instanceof ParametricPartView
                && item.name.startsWith('Fixed')
                && child instanceof DrawerView)
        {
            fixed = item;
            // We were passed the bottom of the shelf, so we need to find its
            // center again for a valid comparison.
            fixedY = y + item.model.height - 3/8;
            drawer = child;
            drawerBottom = child.position.y;
            drawerTop = drawerBottom + child.model.height
        }

        if(fixed && drawer) {
            if(approxGreaterThan(fixedY, drawerBottom)
               && approxLessThan(fixedY, drawerTop))
            {
                return true;
            }
        }
        else if(child instanceof BaseView) {
            box.makeEmpty();
            visibleSize(child, box);
            if(approxOverlaps(y, y+height, box.min.y, box.max.y)) {
                return true;
            }
        }
    }
    return false;
}

/**
 * Detects if the given interval (y, y+height) overlaps any of the doors on the
 * given SectionView.
 */
export const overlapsSectionDoor =
    (view: SectionView, y: number, height: number, except: Object3D | null = null)
        : boolean =>
{
    const box = new Box3();
    for(const child of view.children) {
        if(child == except) continue;

        if(child instanceof DoorView) {
            box.makeEmpty();
            visibleSize(child, box);
            if(approxOverlaps(y, y+height, box.min.y, box.max.y)) {
                return true;
            }
        }
    }
    return false;
}

export const overlapsSectionDrawerFront = (view: SectionView, y: number)
    : boolean =>
{
    const box = new Box3();
    for(const child of view.children) {
        if(child instanceof DrawerView && child.model.panel != null) {
            box.makeEmpty();
            visibleSize(child, box);
            //
        }
    }
    return false;
}
